/* =========================================================
   Couch Potato Landing - minimal JS
   - FAQ accordion (accessible)
   - Sticky mobile ATC visibility + variant/price sync
   - Optional scrolling bar duplicator for seamless marquee
   ========================================================= */
(function () {
  'use strict';

  function initFaq(root) {
    var items = root.querySelectorAll('[data-cp-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-cp-faq-q]');
      var panel = item.querySelector('[data-cp-faq-a]');
      if (!btn || !panel) return;

      var panelId = panel.id || ('cp-faq-panel-' + Math.random().toString(36).slice(2, 9));
      panel.id = panelId;
      btn.setAttribute('aria-controls', panelId);
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
      panel.hidden = btn.getAttribute('aria-expanded') !== 'true';

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
        item.classList.toggle('is-open', !open);
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  }

  function initScrollingBar(root) {
    var track = root.querySelector('[data-cp-strip-track]');
    if (!track || track.dataset.cpStripInit === '1') return;
    var children = Array.prototype.slice.call(track.children);
    children.forEach(function (n) { track.appendChild(n.cloneNode(true)); });
    track.dataset.cpStripInit = '1';
  }

  function initStickyAtc(root) {
    var sticky = root.querySelector('[data-cp-sticky-atc]');
    if (!sticky) return;
    var target = document.querySelector('[data-cp-sticky-anchor]');
    var footer = document.querySelector('[data-cp-footer]');
    function update() {
      var showAfter = target ? (target.getBoundingClientRect().bottom + window.scrollY) : 600;
      var hideBefore = footer ? (footer.getBoundingClientRect().top + window.scrollY - 120) : Infinity;
      var y = window.scrollY + window.innerHeight;
      var withinShowRange = window.scrollY > showAfter - window.innerHeight;
      var aboveFooter = y < hideBefore;
      sticky.classList.toggle('is-visible', withinShowRange && aboveFooter);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function initProductForm(formWrap) {
    if (!formWrap || formWrap.dataset.cpFormInit === '1') return;
    formWrap.dataset.cpFormInit = '1';
    var select = formWrap.querySelector('[data-cp-variant-select]');
    var idInput = formWrap.querySelector('[data-cp-variant-id]');
    var priceEl = formWrap.querySelector('[data-cp-price]');
    var submitBtn = formWrap.querySelector('[data-cp-add-btn]');
    if (!select || !idInput) return;
    function applySelected() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      idInput.value = opt.value;
      if (priceEl && opt.dataset.priceHtml) priceEl.innerHTML = opt.dataset.priceHtml;
      var available = opt.dataset.available === 'true';
      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.setAttribute('aria-disabled', String(!available));
        var labelAvailable = submitBtn.dataset.labelAvailable || 'Add to cart';
        var labelSoldOut = submitBtn.dataset.labelSoldOut || 'Sold out';
        var labelEl = submitBtn.querySelector('[data-cp-add-btn-label]') || submitBtn;
        if (labelEl !== submitBtn) labelEl.textContent = available ? labelAvailable : labelSoldOut;
      }
    }
    select.addEventListener('change', applySelected);
    applySelected();
  }

  function dispatchCartUpdate() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:item-added'));
    document.dispatchEvent(new CustomEvent('cart:build'));
    var drawer = document.querySelector('cart-drawer, cart-notification, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) { /* noop */ }
    }
  }

  function initAjaxAddToCart(formWrap) {
    var form = formWrap.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.cpAjaxInit === '1') return;
    form.dataset.cpAjaxInit = '1';
    form.addEventListener('submit', function (e) {
      var hasProductFormCustomEl = form.closest('product-form');
      if (hasProductFormCustomEl) return;
      e.preventDefault();
      var btn = form.querySelector('[data-cp-add-btn]');
      if (btn) btn.classList.add('is-loading');
      var fd = new FormData(form);
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (data && data.status && data.status >= 400) { console.warn('[cp] add-to-cart error', data); return; } dispatchCartUpdate(); })
        .catch(function (err) { console.warn('[cp] add-to-cart failed', err); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  function init() {
    document.querySelectorAll('[data-cp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-cp-strip]').forEach(initScrollingBar);
    document.querySelectorAll('[data-cp-product-form]').forEach(function (el) { initProductForm(el); initAjaxAddToCart(el); });
    initStickyAtc(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
